module.exports = __webpack_public_path__ + "img/brush-yellowD.4ea040eb.png";